import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, change } from 'redux-form';
import { ButtonToolbar, Button, Collapse, Alert, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { addMonths } from 'date-fns';
import formValueSelector from 'redux-form/lib/formValueSelector';
import { connect } from 'react-redux';
import validate from './Validate';
import Select from '../../../shared/components/form/Select';
import DateField from '../../../shared/components/form/DateField';
import RenderField from '../../../shared/components/form/RenderField';
import Modal from '../../../shared/components/Modal';
import StatusSelector from './StatusSelector';
import ProductTable from './ProductTable';
import { STATUS_SELECTOR } from '../../../shared/utils/constants';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';
import { getFormattedDate } from '../../../shared/utils/smartutils';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const ContractForm = (props) => {
  const {
    t,
    dispatch,
    backHandler,
    handleSubmit,
    dto,
    initialize,
    contractType,
    students,
    responsibleFinancial,
    loadResponsibleFinancial,
    toggleTitles,
    initialDateValue,
    finalValidityDateValue,
    nameValue,
    validityValue,
  } = props;

  const [modal, setModal] = useState(false);
  const [editSummary, setEditSummary] = useState(true);

  const toggleModal = () => {
    setModal(!modal);
  };

  const changeStatusSelect = () => {
    dispatch(change('ContractForm', 'status', STATUS_SELECTOR.ACTIVE));
    toggleModal();
  };

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  useEffect(() => {
    if (dto.sumaryContract) {
      dispatch(change(('ContractForm', 'sumaryContract', dto.sumaryContract)));
    } else {
      dispatch(
        change(
          'ContractForm',
          'sumaryContract',
          t('general.proposal_sumarry')
            .replace('NAMEVALUE', nameValue.fullName)
            .replace('TOTALMESES', validityValue)
            .replace('DATAINICIO', getFormattedDate(initialDateValue))
            .replace('DATAFIM', getFormattedDate(finalValidityDateValue))
        )
      );
    }
  }, [finalValidityDateValue, validityValue, nameValue]);

  useEffect(() => {
    dispatch(
      change(
        'ContractForm',
        'finalValidityDate',
        addMonths(initialDateValue, validityValue)
      )
    );
  }, [validityValue]);

  const enableEditing = (value) => {
    dispatch(change('ContractForm', 'sumaryContract'));
    setEditSummary(!value);
  };

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.canceling-contract-canceled-titles')}
        toggle={changeStatusSelect}
        modal={modal}
        onConfirm={handleSubmit}
      />
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.type')}</span>
          <div className="form_form-group-field">
            <Field
              name="contractType"
              type="text"
              component={Select}
              options={contractType}
              placeholder={t('screens.mnt_contratos.placeholders.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.student')}</span>
          <div className="form_form-group-field">
            <Field
              name="student"
              type="text"
              component={SelectVirtualized}
              options={students}
              onChange={(value) => loadResponsibleFinancial(value.id)}
              placeholder={t('screens.mnt_contratos.placeholders.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.responsible-account')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="responsible1"
              type="text"
              component={Select}
              options={responsibleFinancial}
              placeholder={t('product.placeholders.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.status')}</span>
          <div className="form_form-group-field">
            <Field
              name="status"
              component={StatusSelector}
              onChange={(value) => {
                if (value === STATUS_SELECTOR.CANCELED && dto.id !== 0) {
                  toggleModal();
                }
              }}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.contract-number')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="numberContract"
                type="text"
                component={RenderField}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form__form-group-field">
              <Field name="initialDate" component={DateField} />
            </div>
          </div>
        </div>
        <div className="form__form-group--3_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.validity')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="validity"
                type="number"
                maxLength="2"
                component={RenderField}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.contract_end_date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="finalValidityDate"
                component={DateField}
                minDate={initialDateValue}
                maxDate={addMonths(initialDateValue, validityValue)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.due-date-day')}
            </span>
            <div className="form__form-group-field">
              <Field name="competencyDate" component={DateField} />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <Label className="generic__label">
            {t('general.edit_proposal_sumarry')}
          </Label>
          <Field
            name="activeResumeEdit"
            component={renderCheckBoxField}
            className="colored-click"
            onChange={(event) => {
              if (event.target) {
                enableEditing(event.target.checked);
              }
            }}
          />
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.contract_resume_effective_date')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="sumaryContract"
              type="text"
              disabled={editSummary}
              component="textarea"
              maxLength="250"
              placeholder={t('general.placeholders.resume_warning')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.note')}</span>
          <div className="form__form-group-field">
            <Field
              name="obs"
              type="text"
              component="textarea"
              maxLength="250"
              placeholder={t('screens.mnt_contratos.placeholders.observation')}
            />
          </div>
        </div>
        <div className="form__form-group d-flex justify-content-center card__title">
          <h5 className="bold-text">{t('general.products')}</h5>
        </div>
        <div className="form__form-group">
          <ProductTable data={dto.products} titleId={dto.id} />
        </div>

        <Field
          name="add"
          component={(values) => (
            <Collapse
              isOpen={values.meta.touched && values.meta.invalid}
              className="width100"
            >
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <div className="text-center width100">
                    <Alert color="danger">
                      {values.meta.error && <span>{values.meta.error}</span>}
                    </Alert>
                  </div>
                </div>
              </div>
            </Collapse>
          )}
        />
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          {dto.id !== 0 && (
            <Button color="warning" onClick={toggleTitles}>
              {t('general.titles')}
            </Button>
          )}
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

ContractForm.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  contractType: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  students: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  responsibleFinancial: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  loadResponsibleFinancial: PropTypes.func.isRequired,
  toggleTitles: PropTypes.func.isRequired,
  initialDateValue: PropTypes.oneOfType(PropTypes.date),
  finalValidityDateValue: PropTypes.oneOfType(PropTypes.date),
  nameValue: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  validityValue: PropTypes.func,
};

ContractForm.defaultProps = {
  initialDateValue: new Date(),
  finalValidityDateValue: new Date(),
  nameValue: '',
  validityValue: '',
};

const selector = formValueSelector('ContractForm');
export default withTranslation('common')(
  reduxForm({
    form: 'ContractForm',
    validate,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
  })(
    connect((state) => {
      const initialDateValue = selector(state, 'initialDate');
      const finalValidityDateValue = selector(state, 'finalValidityDate');
      const nameValue = selector(state, 'student');
      const validityValue = selector(state, 'validity');
      const newState = {
        initialDateValue,
        finalValidityDateValue,
        nameValue,
        validityValue,
      };
      return newState;
    })(ContractForm)
  )
);
